export default __webpack_public_path__ + "static/media/LEVEL7.6a727e25.png";